import { createRoot } from 'react-dom/client'
import CarouselInit from './components/CarouselInit'

declare global {
  interface Window {
    routes: { 
      rootUrlWithoutSlash: string,
      domain: string
    }
  }
}

const container = document.getElementById('ss-carousel-target')!
const root = createRoot(container)
root.render(
  <CarouselInit />
)
